// extracted by mini-css-extract-plugin
export default {"input-div":"TextInput_input-div__02yDg","float":"TextInput_float__A1lHy","invalid":"TextInput_invalid__W2AWZ","required":"TextInput_required__Su6SG"};